import React, {useState} from 'react';
import {
    Avatar,
    AvatarBadge,
    Box,
    Button,
    Container,
    Flex,
    Image,
    Menu,
    MenuButton,
    MenuGroup,
    MenuItem,
    MenuItemOption,
    MenuList,
    MenuOptionGroup
} from "@chakra-ui/react";
import MainlLogo from "../../../Logo/drillcut-SVG.svg";
import cart from "../../../Logo/cart.svg"
import users from "../../../Logo/users.svg"
import {MobileDrawer} from './Mobiledrawer';
import {Link, useNavigate} from 'react-router-dom';
import {SearchInstantBox} from './SeachInstantBox';
import userColored from "../../../Logo/user-coloured.svg";
import {CheckCircleIcon} from "@chakra-ui/icons";
import {useDispatch, useSelector} from "react-redux";
import drillcut360 from "../../../Logo/drillcut-360.png";
import {useQuery} from "react-query";
import {laravelAxios} from "../../apiClients/laravelClient";
import {logoutUser, setCurrentBranchID} from "../../../store/features/UserSlice";
import cartBlack from "../../../Logo/cart_blck.svg"
import {isSuperAdmin} from "../../utils";
import {MenuInput} from "../input/MenuInput";

export const Headermobile = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {isLoggedIn, cartQuantity, currentBranchId, allUserInfo} = useSelector((state) => state.user);
    const [superAdminBranchList, setSuperAdminBranchList] = useState([]);

    const {data: allBranchDeatils} = useQuery('branch_infos', () => laravelAxios.get('/branches'), {
        select: res => {
            const branchInfo = {}
            for (const branch of res.data?.data) {
                branchInfo[branch.id] = branch;
            }
            return branchInfo;
        }, enabled: isLoggedIn, refetchOnWindowFocus: false,
    });

    const {data: branchList} = useQuery('branch_list', () => laravelAxios.get('/branch_list'), {
        select: (res) => {
            const branches = []
            for (const dataKey in res.data) {
                branches.push({key: dataKey, value: res.data[dataKey]});
            }
            return branches;
        }, enabled: isLoggedIn, refetchOnWindowFocus: false,
    });

    const selectCurrentBranch = (id) => {
        dispatch(setCurrentBranchID({currentBranchId: id, currentDebtorId: allBranchDeatils[id]?.account_number}));
    }

    const logout = () => {
        dispatch(logoutUser());
        navigate('/login');
    }

    const searchByBranchName = async (e) => {
        const {value} = e.target;
        const res = await laravelAxios.get(`/branch_list?search=${value}`);
        const branches = []
        for (const dataKey in res.data) {
            branches.push({key: dataKey, value: res.data[dataKey]});
        }
        setSuperAdminBranchList(branches.slice(0, 10));
    }

    return (<Container maxW='100%' p='0' display={{base: "block", md: "none"}}>
        <Flex p='20px' flexGrow='1' alignItems='center'>
            <Flex>
                <Box className="mobile_logo">
                    <Link to='/'>
                        <Image height={"30px"} loading='lazy' src={MainlLogo} alt='logo'/>
                    </Link>
                </Box>
            </Flex>
            <Flex justifyContent='flex-end' w='100%' className='header_icons_mt headericons_mobile_view'>
                {isLoggedIn ? (
                    <Menu>
                        <MenuButton as={Avatar} className='header_icons_mt_new_Drillcut icon' bg='white' src={userColored} aria-label="User menu">
                            <AvatarBadge right={'5px'} top={'-5px'} bottom={'none'} border={'none'} color={'#EC7700'}>
                                <CheckCircleIcon width={'15px'} height={'15px'} border={'none'}/>
                            </AvatarBadge>
                        </MenuButton>
                        <MenuList>
                            <MenuGroup>
                                <MenuItem as={Link} to="/360/dashboard" margin="0px" padding="0px">
                                    <Image loading='lazy' src={drillcut360} alt="Drillcut 360 Logo" />
                                </MenuItem>
                            </MenuGroup>
                            {isSuperAdmin(allUserInfo) ? (<>
                                <MenuInput mt="10px" placeHolder="Search Branch Name" changeInput={searchByBranchName}/>
                                <MenuOptionGroup value={currentBranchId}>
                                    {superAdminBranchList?.map((branch) => (
                                        <MenuItemOption mt="10px" value={branch?.key} onClick={() => {
                                            selectCurrentBranch(branch.key);
                                            navigate('/360/dashboard');
                                        }}>
                                            {branch?.value}
                                        </MenuItemOption>))}
                                    <MenuItem borderTop="2px solid" borderColor="inherit" opacity="1" mt="10px" onClick={logout}>Log Out</MenuItem>
                                </MenuOptionGroup></>) : (
                                <MenuOptionGroup value={currentBranchId} type='radio' title="Select Branch">
                                    {branchList?.map((branch) => (
                                        <MenuItemOption onClick={() => {
                                            selectCurrentBranch(branch?.key)
                                            navigate('/360/dashboard');
                                        }} value={branch?.key}>{branch?.value}</MenuItemOption>))}
                                    <MenuItemOption borderTop="2px solid" borderColor="inherit" opacity="1" onClick={logout}>Log Out</MenuItemOption>
                                </MenuOptionGroup>
                            )}
                        </MenuList>
                    </Menu>
                ) : (
                    <Button as={Link} to='/login' className="icons_with_text_button" aria-label="Account Login">
                        <Avatar className='header_icons_mt_new_Drillcut icon' bg='white' src={users} />
                        <span className='icons_with_text_button_text'>Account Login</span>
                    </Button>
                )}
                <Button as={Link} to='/cart' className="icons_with_text_button" aria-label="View cart">
                    <Avatar className='icon' bg='white' src={cartQuantity ? cart : cartBlack}>
                        <AvatarBadge backgroundColor={cartQuantity ? '#EC7700' : 'black'} fontSize="16px" width="16px" height="21px" borderRadius="50%" top="-5px" bottom={'none'} border={'none'}>
                            {cartQuantity ? cartQuantity : 0}
                        </AvatarBadge>
                    </Avatar>
                </Button>
                <MobileDrawer/>
            </Flex>
        </Flex>
        <SearchInstantBox/>
    </Container>)
}